import React, {createContext, useReducer} from 'react'

export const SET_APPS_LIST = 'SET_APPS_LIST'
export const SELECT_APP = 'SELECT_APP'
export const SET_SHOW_APP_POPUP = 'SET_SHOW_APP_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_APPS_LIST:
      return { ...data, apps_list: payload.data }
    case SELECT_APP:
      return {
        ...data,
        selected_app: payload.data.selected_app,
        show_app_popup: payload.data.show_app_popup,
      }
    case SET_SHOW_APP_POPUP:
      return {
        ...data,
        show_app_popup: payload.data,
        selected_app: payload.data ? data.selected_app : {},
      }
    default:
      return data
  }
}

const initialState = {
  apps_list: [],
  selected_app: {},
  show_app_popup: false,
}

const AppsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <AppsContext.Provider value={[state, dispatch]}>
      {children}
    </AppsContext.Provider>
  )
}

export const AppsContext = createContext(initialState)
export default AppsStore
